// Hook that returns info if location form has any missing information

import { useState, useEffect } from 'react';
import { CreateLocationFormValues } from '../CreateLocation/CreateLocation';

const useMissingLocationInfo = (values: CreateLocationFormValues): boolean => {
  const [isAddressComponentsMissing, setIsAddressComponentsMissing] = useState(false);

  useEffect(() => {
    if (values.google_place_id) {
      setIsAddressComponentsMissing(!values.address_1 || !values.city || !values.state);
    }

    return (): void => {
      setIsAddressComponentsMissing(false);
    };
  }, [values.google_place_id, values.city, values.zip, values.address_1, values.state]);

  return isAddressComponentsMissing;
};

export default useMissingLocationInfo;
